import {useQuery} from '@tanstack/react-query';
import {UserService} from 'client';
import {getService} from 'utilities';

export const useJWTToken = () => {
  const queryFn = getService(UserService).getTokenApiV1AuthTokenGet;
  const hasQueryFn = typeof queryFn === 'function';
  const {
    data: token,
    isLoading,
    error,
  } = useQuery<string | null>({
    queryKey: ['jwtToken'],
    queryFn: hasQueryFn ? queryFn : async () => null,
    enabled: hasQueryFn,
    retry: hasQueryFn ? 2 : false,
    retryDelay: 1000,
    throwOnError: false,
  });

  return {
    token,
    isLoading,
    error,
  };
};

export const useCollabJWTToken = () => {
  const queryFn = getService(UserService).getCollabTokenApiV1AuthCollabTokenGet;
  const hasQueryFn = typeof queryFn === 'function';
  const {
    data: token,
    isLoading,
    error,
  } = useQuery<string | null>({
    queryKey: ['collabJwtToken'],
    queryFn: hasQueryFn ? queryFn : async () => null,
    enabled: hasQueryFn,
    retry: hasQueryFn ? 2 : false,
    retryDelay: 1000,
    throwOnError: false,
  });

  return {
    token,
    isLoading,
    error,
  };
};
